import KTBSButton, { KTBSButtonColor, KTBSButtonSize } from "general/components/OtherKeenComponents/KTBSButton";
import KTBSCard from "general/components/OtherKeenComponents/KTBSCard";
import AppColors from "general/constants/AppColors";
import { useTranslation } from "react-i18next";
import BankCard from "../BankCard";
import EmptyView from "general/components/Others/EmptyView";
import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import DialogAddBankAccountView from "../DialogAddBankAccountView";
import { AppCustomDialogHelper } from "general/components/AppDialogCustom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import AppConstants from "general/constants/AppConstants";
import UIHelper from "general/helpers/UIHelper";
import Utils from "general/utils/Utils";

BankAccountsView.propTypes = {
    agencyId: PropTypes.string,
    agencyDetail: PropTypes.object,
    banksList: PropTypes.array,
    getAgencyBankList: PropTypes.func,
};

function BankAccountsView(props) {
    const { agencyId, agencyDetail, banksList, getAgencyBankList } = props;
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.auth);

    const isAgencyInfo = useMemo(() => {
        return Number(user?.agency?.agencyId) === Number(agencyId)
    }, [user, agencyId])
    const adminRole = user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;

    const disabledEditBank = useMemo(() => {
        return agencyDetail?.numberOfSignedContracts > 0 && !adminRole
    }, [agencyDetail, adminRole])

    const handleRefresh = () => {
        getAgencyBankList();
    };

    const handleAddNew = (item) => {
        AppCustomDialogHelper.show(
            !!item ? 'Chỉnh sửa tài khoản ngân hàng' : 'Thêm tài khoản ngân hàng',
            <DialogAddBankAccountView
                agencyId={agencyId}
                item={item}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    handleRefresh();
                }}
            />,
            'md',
            false,
            true
        );
    };

    return (
        <div className="">
            {UIHelper.buildCard(
                <div className="pb-4">
                    {/* header */}
                    <div className="px-4 pt-4 pb-3 d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column">
                            <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                Danh sách tài khoản ngân hàng
                            </span>
                            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                Tổng:{' '}
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                    {Utils.formatNumber(banksList?.length)} tài khoản
                                </span>
                            </span>
                        </div>

                        {/* <div className="d-flex gap-3">
                            {isAgencyInfo && (
                                <KTBSButton
                                    color={KTBSButtonColor.success}
                                    title={t('Thêm tài khoản ngân hàng')}
                                    size={KTBSButtonSize.default}
                                    borderRadius={5}
                                    buttonTitleFontWeight="600"
                                    iconElement={<i className="fa-regular fa-circle-plus" style={{ fontSize: 15 }} />}
                                    onPress={handleAddNew}
                                    height={43}
                                    buttonTitleFontSize={14}
                                />
                            )}
                        </div> */}
                    </div>

                    <div className="px-5">
                        {banksList?.length ? (
                            <div className="row">
                                {banksList
                                    .sort((a, b) => (b.defaultAccount ? 1 : 0) - (a.defaultAccount ? 1 : 0))
                                    .map((item, index) => (
                                        <div key={`BANK_ACCOUNT_${item?.bankAccountId ?? index}`} className="col-xl-4 col-lg-6 col-md-6 col-12 py-2 min-w-325px">
                                            <BankCard
                                                item={item}
                                                onEdit={() => handleAddNew(item)}
                                                disabledEditBank={disabledEditBank}
                                            />
                                        </div>
                                    ))}
                            </div>
                        ) : (
                            <EmptyView
                                icon={imgEmptyNoData}
                                title="Không có dữ liệu để hiển thị"
                                text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                            />
                        )}
                    </div>
                </div>,
                false,
                false,
                true,
                false,
                AppColors.gray[300],
                true
            )}
        </div>
    );
}

export default BankAccountsView;